import { EntityReference } from '../../core/entities/shared/entity-reference.entity';
import { ShoppingSessionFormControls } from '../form-controls/shopping-session.form-controls';
import { ShoppingSessionFormOptions } from '../form-options/shopping-session.form-options';
import { BaseForm } from './base.form';

export class ShoppingSessionForm extends BaseForm<ShoppingSessionFormControls> {
  formGroup = this.createFormGroup(ShoppingSessionFormControls);
  override options = new ShoppingSessionFormOptions();

  get date(): Date {
    return this.controls.date.value;
  }

  get store(): EntityReference | null {
    return this.controls.store.value;
  }
}
